import { Reveal } from "@/components/Reveal";
import { MapPin } from "lucide-react";
import { AREAS } from "@/constants/assets";

export const AreasWeCover = () => (
  <section id="areas" data-testid="areas-section" className="py-20 sm:py-28 bg-cream">
    <div className="mx-auto max-w-5xl px-5 sm:px-8 text-center">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-turquoise">
          Service area
        </p>
        <h2 className="mt-3 font-display fluid-h2 font-semibold text-navy">
          Areas We <span className="italic text-turquoise">Cover</span>
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-navy/65 text-lg">
          Professional carpet and upholstery cleaning across Airdrie, Glasgow,
          East Kilbride, Lanarkshire and surrounding areas.
        </p>
      </Reveal>

      <Reveal delay={0.1}>
        <ul className="mt-10 flex flex-wrap justify-center gap-3">
          {AREAS.map((a) => (
            <li
              key={a}
              data-testid={`area-tag-${a.toLowerCase().replace(/\s/g, "-")}`}
              className="inline-flex items-center gap-2 rounded-full bg-white px-5 py-2.5 text-sm font-semibold text-navy ring-1 ring-navy/10 shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:ring-turquoise hover:text-turquoise"
            >
              <MapPin className="h-4 w-4 text-turquoise" />
              {a}
            </li>
          ))}
        </ul>
      </Reveal>
    </div>
  </section>
);
